// Scan sounds should only play for mobile
export const usePlayScanSounds = () => {
  return () => {};
};
